export const pdfRulesEvidenciasSeloEnum = {
    umArquivo: 1,
    umOuDoisArquivos: 2,
    qtdAtendInfoOuQtdDiagnostico: 3,
    ilimitado: 4
}


// 1 - Permitir o envio de APENAS 01 arquivo PDF nas perguntaids
// 1, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15

// 2 - Permitir o envio de 01 OU 02 arquivos PDF na perguntaid 13

// 3 - Permitir a quantidade de arquivos PDFs que está descrita OU no campo 
// Quantidade de Atendentes Informada no Diagnóstico OU no campo Quantidade Atual de Atendentes(o que for maior) na perguntaid 3

// 4 - Permitir arquivos PDFs ilimitados na perguntaid 2

export function rulesFile(perguntaId, quantidadeArquivo, quantidadeArquivoDadosComplementares, valorDiagnostico, atualizacaoAtendentes) {

    const umArquivo = [1, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15]
    const pergunta3Maior = valorDiagnostico > atualizacaoAtendentes ? valorDiagnostico : atualizacaoAtendentes


    if (umArquivo.includes(perguntaId)) {
        if (quantidadeArquivo >= 1) {
            return "Essa pergunta só aceita um arquivo"
        }

    } else if (perguntaId == 13) {
        if (quantidadeArquivo >= 2) {
            return "Essa pergunta só aceita até dois arquivos"
        }
    } else if (perguntaId == 3) {
        if (quantidadeArquivo >= pergunta3Maior) {
            return `Como foram informados ${pergunta3Maior} atendentes, você só poderá enviar até ${pergunta3Maior} arquivos.`
        }
    }
    return false

}
